module.exports = __webpack_public_path__ + "static/media/president.01d80b30.png";